import type { Middleware } from '@reduxjs/toolkit';

import { navigate } from './navigate';
import { callHistoryMethod, HistoryMethod } from './actions';

// Plain Redux middleware (not a listener): navigation actions are consumed here and never reach the reducers.
const navigationMiddleware: Middleware = () => (next) => (action) => {
  if (!callHistoryMethod.match(action)) {
    return next(action);
  }

  const { payload } = action;
  switch (payload.method) {
    case HistoryMethod.PUSH:
    case HistoryMethod.REPLACE: {
      const [to, state] = payload.args;
      navigate(to, { replace: payload.method === HistoryMethod.REPLACE, state });
      break;
    }
    case HistoryMethod.GO_BACK:
      navigate(-1);
      break;
  }

  return undefined;
};

export default navigationMiddleware;
